import { WorkaroundTimelineCompliance } from '../../../../../shared/types/business-functions-workarounds';

export type Workaround = {
  uuid: string;
  name: string;
  workaroundDescription: string;
  runtimeHours: number | null;
  workaroundTimelineCompliance: WorkaroundTimelineCompliance;
  isDefined: boolean;
};

export type ItApplication = {
  uuid: string;
  name: string;
  description: string;
  tier: {
    color: string;
    name: string;
  };
  mto: number;
  rpo: number;
  rto: number;
  sla: number;
  qualitativeFactors: Workaround[];
  businessFunctions: Workaround[];
  processAreas: Workaround[];
};

export type ITApplicationWithWorkarounds = {
  getITApplicationWithWorkarounds: ItApplication;
};

export enum WorkaroundDefinedType {
  NO_WORKAROUND = 'No Workaround',
  INFINITE = 'Infinite',
}
